<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  [baseZIndex]="10002"
  [draggable]="false"
  [styleClass]="'all-changes-dialog'"
  appendTo="body"
  (onHide)="onHide()"
>
  <ng-template pTemplate="header">
    <span class="dialog-header">
      {{ 'VIEW_ALL_CHANGES_POPUP' | translate }} -
      <span *ngIf="component" class="dialog-subheader"> {{ component.componentDisplayName || component.componentName }}</span>
    </span>
  </ng-template>

  <div *ngIf="component" class="all-changes-container">
    <!-- Changes Table -->
    <p-table [value]="changes" styleClass="repo-table">
      <ng-template pTemplate="header">
        <tr>
          <th scope="col">{{ 'ACTION' | translate }}</th>
          <th scope="col">{{ 'DATE_TIME' | translate }}</th>
          <th scope="col">{{ 'CHANGED_BY' | translate }}</th>
          <th scope="col">{{ 'REMARKS' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-detail>
        <tr>
          <td class="action-cell">{{ detail.action | translate }}</td>
          <td>{{ detail.dateTime | date: dateTimeFormat }}</td>
          <td>
            <div class="created-by-cell">
              <p-avatar
                [label]="getAuthorDisplayName(detail.author) ? getAuthorDisplayName(detail.author)[0] : ''"
                shape="circle"
                [style]="{ 'background-color': getAuthorBgColor(getAuthorDisplayName(detail.author)) }"
                size="small"
                styleClass="created-by-avatar avatar-text-color"
              ></p-avatar>
              <span class="created-by-name">{{ getAuthorDisplayName(detail.author) }}</span>
            </div>
          </td>
          <td class="remarks-cell" [style.white-space]="'pre-line'">{{ getRemarks(detail) }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr class="no-records">
          <td colspan="4" class="text-center">
            <div *ngIf="loading" class="loading-container">
              <p-progressSpinner></p-progressSpinner>
            </div>
            <span *ngIf="!loading">{{ 'NO_CHANGES_RECORDED' | translate }}</span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <ng-template pTemplate="footer">
  </ng-template>
</p-dialog>
